// import "../styleSheets/pagenotfound.css";
import React from "react";
import underContructionImg from "../assets/underConstruction.jpg";

const PageNotFound = () => {
  return (
    <>
      <div className="m-auto w-1/2">
        <img src={underContructionImg} alt="" />
      </div>
    </>
  );
};

export default PageNotFound;
